import React from 'react';
import { useTutorial } from '../../../contexts/TutorialContext';
import TutorialSpotlight from './TutorialSpotlight';
import TutorialTooltip from './TutorialTooltip';
import './Tutorial.css';

export const TutorialModal: React.FC = () => {
  const { isActive, skipTutorial } = useTutorial();

  if (!isActive) {
    return null;
  }

  // Handle click on overlay (outside tooltip and spotlight)
  const handleOverlayClick = (e: React.MouseEvent) => {
    // Only close if clicking directly on the backdrop, not the tooltip
    if (e.target === e.currentTarget) {
      // Optional: close on backdrop click
      // skipTutorial();
    }
  };

  return (
    <div className="tutorial-modal" onClick={handleOverlayClick}>
      <TutorialSpotlight />
      <TutorialTooltip />
    </div>
  );
};

export default TutorialModal;
